export class InitInstructionsState {
	static readonly type: string = '[Instructions] InitInstructionsState';
}

export class ClearInstructionsState {
	static readonly type: string = '[Instructions] ClearInstructionsState';
}

export class ResetInstructionsState {
	static readonly type: string = '[Instructions] ResetInstructionsState';
}

export class GetInstitutionInstructions {
	static readonly type: string = '[Instructions] GetInstitutionInstructions';
	constructor(
		public countryCode: string,
		public institution: string,
		public paymentType: string
	) {}
}

export class GetInstitutionCountries {
	static readonly type: string = '[Instructions] GetInstitutionCountries';
	constructor(
		public institution: string,
		public paymentType: string
	) {}
}
